import { ScreenId } from "@/js/value-objects/screen-id";

export default function(mock) {
  const baseUri = "/api/screen_authority";

  mock.onPost(baseUri).reply(function(status) {
    window.console.log(status);
    return success();
    // return failure();
    //return noData();
    // return successScreenCrudReadOnly();
    // return successScreenCrudOpeOnly();
  });

  // eslint-disable-next-line no-unused-vars
  const noData = () => {
    return [
      200,
      {
        count: 0,
        results: []
      }
    ];
  };

  // eslint-disable-next-line no-unused-vars
  const success = () => {
    const results = Screens.get().map((screenId, index) => ({
      screen_id: screenId,
      disp_no: index + 1,
      auth_level: "1",
      screen_crud: ScreenId.factory(screenId).isOperation() ? "A" : "R"
    }));
    return [
      200,
      {
        count: results.length,
        results: results
      }
    ];
  };

  /**
   * 参照権限のみの場合
   */
  // eslint-disable-next-line no-unused-vars
  const successScreenCrudReadOnly = () => {
    const results = Screens.get()
      .filter(screen => !ScreenId.OPERATION_LIST.includes(screen))
      .map((screenId, index) => ({
        screen_id: screenId,
        disp_no: index + 1,
        auth_level: "1",
        screen_crud: "R"
      }));
    return [
      200,
      {
        count: results.length,
        results: results
      }
    ];
  };

  /**
   * 操作権限のみの場合
   */
  // eslint-disable-next-line no-unused-vars
  const successScreenCrudOpeOnly = () => {
    const results = ScreenId.OPERATION_LIST.map((screenId, index) => ({
      screen_id: screenId,
      disp_no: index + 1,
      auth_level: "1",
      screen_crud: "CRU"
    }));
    return [
      200,
      {
        count: results.length,
        results: results
      }
    ];
  };

  // eslint-disable-next-line no-unused-vars
  const failure = () => {
    return [
      500,
      {
        error: {
          code: "ERAE50001",
          message: {
            value: "データの取得に失敗しました"
          }
        }
      }
    ];
  };
}

export class Screens {
  static get = () => {
    return [
      ScreenId.SF0001,
      ScreenId.SF0101,
      ScreenId.SF0102,
      ScreenId.SF0201,
      ScreenId.SF0202,
      ScreenId.SF0203,
      ScreenId.SF0204,
      ScreenId.SF0205,
      ScreenId.SF2001,
      ScreenId.SF0301,
      ScreenId.SF0302,
      ScreenId.SF0303,
      ScreenId.SF0304,
      ScreenId.SF0305,
      ScreenId.SF0306,
      ScreenId.SF0307,
      ScreenId.SF0308,
      ScreenId.SF0402,
      ScreenId.SF0403,
      ScreenId.SF0404,
      ScreenId.SF0405,
      ScreenId.SF0406,
      ScreenId.SF0601,
      ScreenId.SF0602,
      ScreenId.SF0603,
      ScreenId.SF0604,
      ScreenId.SF0605,
      ScreenId.SF0606,
      ScreenId.SF0607,
      ScreenId.SF0608,
      ScreenId.SF0609,
      ScreenId.SF0610,
      ScreenId.SF1001,
      ScreenId.SF1002,
      ScreenId.SF1201,
      ScreenId.SF1202,
      ScreenId.SF1203,
      ScreenId.SF1204,
      ScreenId.SF1205,
      ScreenId.SF1206,
      ScreenId.SF1207,
      ScreenId.SF1208,
      ScreenId.SF1301,
      ScreenId.SF1303,
      ScreenId.SF1401,
      ScreenId.SF1402,
      ScreenId.SF1403,
      ScreenId.SF1404,
      ScreenId.SF1405,
      ScreenId.SF1406,
      ScreenId.SF1407,
      ScreenId.SF1408,
      ScreenId.SF1501,
      ScreenId.SF1502,
      ScreenId.SF1503,
      ScreenId.SF1504,
      ScreenId.SF1505,
      ScreenId.SF1506,
      ScreenId.SF1507,
      ScreenId.SF1508,
      ScreenId.SF1701,
      ScreenId.SF1801,
      ScreenId.SF1802,
      ScreenId.SF1803,
      ScreenId.SF1901,
      ScreenId.SF1902,
      ScreenId.SF1903,
      ScreenId.SF1904
    ];
  };
}

export class ScreenAuthorityMock {
  static get = () => {
    const results = Screens.get().map((screenId, index) => ({
      screen_id: screenId,
      disp_no: index + 1,
      auth_level: "1",
      screen_crud: "A"
    }));
    return results;
  };
}
